export default {
  hasError: false,
  extraCredits: [],
  initialCredits: [],
  standardCredits: [],
  lastTransactions: [],
  plan: {}
};
